/**
 * @author gll
 * 功能：供应商协作平台
 */

// 发货包件数设置
import { PackageSettingsService } from './packageSettings'
export const packageSettings = new PackageSettingsService('/api/procure/supplier/packageSettings')

// 发货包件数控制
import { PackageControlService } from './packageControl'
export const packageControl = new PackageControlService('/api/procure/supplier/packageControl')

// 代储出版社可预约数控制
import { ReservationControlService } from './reservationControl'
export const reservationControl = new ReservationControlService('/api/procure/supplier/reservationControl')
